import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Menu, Checkbox, Collapse} from "antd";
import "./SearchDropdown.scss";
import Input from "../common/Input";
import search_icon from "../../svg/search_icon.svg";
import { createOtherSpecialization } from "../../store/apiCalls/profileDetails";
import OtherSubject from "../OtherSubject/OtherSubject";

const SearchDropdown = (props) => {
  const {
    options,
    index,
    onChange,
    name,
    selected,
    selectedValue,
    placeholder,
    label,
    labelClass,
    disabled,
    removeAsterisk,
    subjectId
  } = props;
  const dispatch = useDispatch();
  const [other, setOther] = useState({show: false, specialization: '', disabled: true});
  const [dropOptions, setDropOptions] = useState(Array.isArray(options) ? options : []);
  const [search, setSearch] = useState("");
  const [activeKey,setActiveKey] = useState('0');
  const [showSubject, setShowSubject] = useState(false);
  
  useEffect(() => {
    if (Array.isArray(options)) {
      setDropOptions(options);
    }
    // eslint-disable-next-line
  }, [options]);
  const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };

  const handleAddOthers = async () => {
    if(other.specialization && !other.disabled) {
      const queryParams = {
        data: {
          specialization: other.specialization,
          specializationId: other._id ? other._id : ""
        },
        headers
      };
      dispatch({ type: 'SET_LOADER', payload: true});
      const addResp = await createOtherSpecialization(queryParams);
      dispatch({ type: 'SET_LOADER', payload: false});
      if(addResp.data?.success) {
        setOther({show: false, specialization: '', disabled: true})
        props.handleOtherOption(addResp.data?.data)
      }
    } else if(other.disabled) {
      setOther({...other, disabled: false})
    }
  }

  const handleOptionSelect = (value, index) => {
    if(value === "Other Subject (choose this option to register your subject)" && selectedValue.length < 3) {
      setOther({...other, show: true, disabled: false})
      setShowSubject(true);
    } else {
      onChange({target: {value, name}},index)
    }
    setActiveKey(null)
  }
  const onSearchChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      let filterActivity = dropOptions.filter((ac) => {
        return ac.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setDropOptions(filterActivity);
    } else {
      setDropOptions(options);
    }
  };
  
  const optionMenu = (
    <>
      <div>
        <div className="search-dropdown">
          <Input
            // type="Search"
            placeholder={name === "type" ? "Search for Type" : "Search for Subject"}
            // allowClear
            preIconClass={!search && search_icon}
            value={search}
            className={
              search
                ? "form-control active-input search-result"
                : "form-control grey-input with_icon"
            }
            handleChange={(e) => onSearchChange(e)}
          />
        </div>
        {selectedValue?.length > 0 && (
          <>
            Selected {selected??name}s
            <Checkbox.Group>
              {selectedValue.map((exp, i) => (
                <Menu key={i}>
                  <Menu.Item onClick={(e) => handleOptionSelect(exp, index)}>
                    <input
                      type="checkbox"
                      key={i}
                      value={exp}
                      name={name}
                      id={name}
                      checked={selectedValue?.includes(exp)}
                      // onChange={(e) => handleOptionSelect(e.target.value, index)}
                    />
                    {exp}
                  </Menu.Item>
                </Menu>
              ))}
            </Checkbox.Group>
            <br />
          </>
        )}
        {dropOptions === options ? `Polular ${selected??name}s` : `Searched ${selected??name}s`}
        <Checkbox.Group>
          {dropOptions?.map((exp, i) => {
            if (!selectedValue?.includes(exp))
              return (
                <Menu key={i}>
                  <Menu.Item onClick={() => handleOptionSelect(exp, index)}>
                    <input
                      type="checkbox"
                      key={i}
                      value={exp}
                      name={name}
                      id={name}
                      checked={selectedValue?.includes(exp)}
                      // onChange={(e) => handleOptionSelect(e.target.value, index)}
                    // required={required}
                    />
                    {exp}
                  </Menu.Item>
                </Menu>
              );
            else {
              return null;
            }
          })}
        </Checkbox.Group>
      </div>
    </>
  );
  return (
    <>
      <div className=""
        style={disabled ? { pointerEvents: "none", cursor: "pointer", opacity: "0.4" } : {}}
      >
        <label className={labelClass}>{label} <small className="input-required">{removeAsterisk ? null : '*'}</small></label>
        <div
          className="filter-heading activity-filter-txt"
        // style={{ cursor: "pointer", pointerEvents:"none", opacity: "0.4" }}
        >
          <Collapse onChange={(e) => setActiveKey(activeKey === "1" ? null : "1")} activeKey={activeKey} expandIconPosition="right" className={selectedValue?.length !== 0 ? "value-fill" : "value"}>
            <Collapse.Panel  header={placeholder} key={"1"} >
              <p>{optionMenu}</p>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>
      {other.show &&  (
        <OtherSubject showSubject={showSubject} setShowSubject={setShowSubject} props={props} other={other} setOther={setOther} subjectId={subjectId} subjectType={"profile"} />
        // <Input readOnly={other.disabled} className={"form-control active-input specialization-input"} value={other.specialization} postTextClass={other.disabled ? 'EDIT' : 'ADD'} onIconClick={handleAddOthers} handleChange={(e) => setOther({...other, specialization: e.target.value})} type="text" disabled={other.disabled} />
      )}
    </>
  );
};
export default SearchDropdown;